import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
// Constants
import { PAGE_ERROR_MESSAGE_STATE_SLICE_KEY } from './state/page-error-message.reducer';
// NgRx actions
import { removePageErrorMessages } from './state/page-error-message.action';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/common";
import * as i3 from "../../directives/icon/icon.directive";
function PageErrorMessageComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
    i0.ɵɵelement(3, "div", 3);
    i0.ɵɵelementStart(4, "div", 4)(5, "div", 5);
    i0.ɵɵlistener("click", function PageErrorMessageComponent_ng_container_0_Template_div_click_5_listener() { const message_r2 = i0.ɵɵrestoreView(_r1).$implicit; const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.clearErrorMessage(message_r2)); });
    i0.ɵɵelementStart(6, "span");
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(7, "svg", 6);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const message_r2 = ctx.$implicit;
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHTML", message_r2, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("name", "icon-close");
} }
/**
 * Page Error Message Component
 *
 * Simple component for displaying an error message at the top of a page.
 */
export class PageErrorMessageComponent {
    constructor(store) {
        this.store = store;
        this.messages = [];
        this.isAlive = true;
        this.mapStateToComponent = (state) => {
            this.messages = state;
        };
    }
    ngOnInit() {
        this.store
            .select(PAGE_ERROR_MESSAGE_STATE_SLICE_KEY)
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(this.mapStateToComponent);
    }
    ngOnDestroy() {
        this.isAlive = false;
    }
    clearErrorMessage(message) {
        this.store.dispatch(removePageErrorMessages({ messages: [message] }));
    }
}
PageErrorMessageComponent.ɵfac = function PageErrorMessageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PageErrorMessageComponent)(i0.ɵɵdirectiveInject(i1.Store)); };
PageErrorMessageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PageErrorMessageComponent, selectors: [["ycn-page-error-message"]], standalone: false, decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [1, "page-message", "page-message-error"], [1, "container"], [1, "page-message-text", 3, "innerHTML"], [1, "page-message-actions"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["ycnIcon", "", 3, "name"]], template: function PageErrorMessageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, PageErrorMessageComponent_ng_container_0_Template, 8, 2, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngForOf", ctx.messages);
    } }, dependencies: [i2.NgForOf, i3.IconDirective], encapsulation: 2 });
